import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function MobileBanner() {
  const [timeLeft, setTimeLeft] = useState(45 * 60); // 45 minutes
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Show banner after 5 seconds
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Countdown logic
    const savedStartTime = sessionStorage.getItem('countdownStartTime');
    const now = Math.floor(Date.now() / 1000);
    if (savedStartTime) {
      const elapsed = now - parseInt(savedStartTime, 10);
      const remaining = Math.max(0, 45 * 60 - elapsed);
      setTimeLeft(remaining);
    } else {
      sessionStorage.setItem('countdownStartTime', now.toString());
    }
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => {
      clearTimeout(showTimer);
      clearInterval(timer);
    };
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  if (isDismissed) return null;
  return <AnimatePresence data-id="element-102">
      {isVisible && <motion.div initial={{
      y: -80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -80,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="md:hidden fixed top-0 left-0 right-0 z-50 bg-[#C41E3A] text-white py-2.5 px-4 shadow-lg" data-id="element-103">
          <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-3 text-white/80 hover:text-white" aria-label="Cerrar banner" data-id="element-104">
            <XIcon className="w-4 h-4" data-id="element-105" />
          </button>

          <div className="flex flex-col items-center gap-0.5 pr-4" data-id="element-106">
            <span className="text-sm font-bold leading-tight" data-id="element-107">
              Oferta por Lanzamiento HOY en $6.99
            </span>
            <span className="text-xs font-bold opacity-90" data-id="element-108">
              Expira en:{' '}
              <span className="font-mono tracking-wider" data-id="element-109">
                {formatTime(timeLeft)}
              </span>
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}